export enum WorkspaceItemType {
	All = 0,
	Separator = 1,
	ExternalLink = 2,
	NewTableViewRecord = 4,
	Dashboard = 6,
  Widget = 7
}